const SHOULD_SHOW_LAST_LOGIN_KEY = 'SHOULD_SHOW_LAST_LOGIN'

export const cleanShouldShowLastLogin = (): void => {
  sessionStorage.removeItem(SHOULD_SHOW_LAST_LOGIN_KEY)
}

export const setShouldShowLastLogin = (value: boolean): void => {
  sessionStorage.setItem(SHOULD_SHOW_LAST_LOGIN_KEY, value ? 'true' : 'false')
}

export const isShouldShowLastLoginDefined = (): boolean => {
  const shouldShowLastLogin = sessionStorage.getItem(SHOULD_SHOW_LAST_LOGIN_KEY)
  return shouldShowLastLogin !== null
}

export const isShouldShowLastLogin = (): boolean => {
  const shouldShowLastLogin = sessionStorage.getItem(SHOULD_SHOW_LAST_LOGIN_KEY)
  return shouldShowLastLogin === 'true'
}
